// /app/frontend/src/lib/notificationsApi.js
//
// Thin API client for the In-App Notification Center. Kept isolated from
// the rest of `lib/api.js` so future Feed features can import it without
// pulling in unrelated axios interceptors — and so it can be swapped for
// SSE / websockets later without touching call sites.

import api from "./api";

export async function fetchUnreadCount() {
  const { data } = await api.get("/notifications/unread-count");
  return Number(data?.unread_count) || 0;
}

export async function fetchNotifications({ limit = 30, before, unreadOnly = false } = {}) {
  const params = new URLSearchParams();
  if (limit) params.set("limit", String(limit));
  if (before) params.set("before", before);
  if (unreadOnly) params.set("unread_only", "true");
  const qs = params.toString();
  const { data } = await api.get(`/notifications${qs ? `?${qs}` : ""}`);
  return {
    items: data?.items || [],
    unreadCount: Number(data?.unread_count) || 0,
  };
}

export async function markNotificationRead(notificationId) {
  const { data } = await api.post(`/notifications/${notificationId}/read`);
  return {
    changed: Boolean(data?.changed),
    unreadCount: Number(data?.unread_count) || 0,
  };
}

export async function markAllNotificationsRead() {
  const { data } = await api.post(`/notifications/read-all`);
  return Number(data?.marked) || 0;
}
